import React from 'react';

type Props = {
    automationId        : string
    fadeTime            : number
    close               : callback
}

export default function AutomationApplied(props:Props) {

    const openAutomation = () => {
        gd.goTo('automation/{0}'.f(props.automationId))
        props.close();
    }

    const style : style = {
        transition: "opacity " + props.fadeTime + "s"
    }

    const classes = Classes("notification","h-100-percent", "info")

    return (
        <div className={classes} style={style}>
            <div className="flex-row-left-center" onClick={openAutomation}>
                <div className="left-indicator"></div>
                <div className="i5-automation ui5-color-action fs-15 m-l-3"/>
                <div className="message ui5-txt-not-important-small m-l-10">
                    {/*Automation {props.automationId} has been applied*/}
                    Automation applied
                </div>
            </div>

            <div className="close i5-delete" onClick={props.close}/>
        </div>





    )

}
